module.exports = {
  async getTags(params) {
    const url = `${this.url}/${this.version}/tags`;
    const response = await this.get(url, null, this.buildSessionHeaders());
    return response.data;
  },
};



// WEBPACK FOOTER //
// ./src/libs/api_client/modules/tags_api.js